import { render, staticRenderFns } from "./Bee.vue?vue&type=template&id=367ab05c&scoped=true&"
import script from "./Bee.vue?vue&type=script&lang=js&"
export * from "./Bee.vue?vue&type=script&lang=js&"
import style0 from "./Bee.vue?vue&type=style&index=0&id=367ab05c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367ab05c",
  null
  
)

export default component.exports